import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import YouTubeTouchpoint from '../../../../../components/Touchpoints/YouTubeTouchpoint/YouTubeTouchpoint';

export default function YouTubeAccordion() {
  return (
    <Accordion
      disableGutters
      defaultExpanded
      sx={{
        '& .MuiAccordionSummary-root': {
          backgroundColor: 'common.white',
          alignItems: 'center',
          height: '48px',
          borderBottom: '1px solid #C7D8F9',
          borderTop: '1px solid #C7D8F9',
          pl: 0,
          mt: '24px',

          '& .MuiAccordionSummary-content': {
            textAlign: 'center',
            height: 'initial',
          },
          '& .MuiAccordionSummary-expandIconWrapper': {
            marginRight: 0,
          },
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontWeight: 700,
          }}
        >
          YOUTUBE
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ backgroundColor: '#F6F6F6', p: '22px 16px' }}>
        <YouTubeTouchpoint />
      </AccordionDetails>
    </Accordion>
  );
}
